import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "commonReducer",
  initialState: {
    settings: {},
    accessorDetails: {},
    productSponsorId: "",
    productSponsorName: "",
    accessProfileId: "",
    accessProfileType: "",
    accessorPrivileges: "",
    isRiccAdministrator: false,
    showChangeProductManufacturer: true,
    riccAdmApprovalRequiredCode: "",
  },
  reducers: {
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    setAccessorDetails: (state, action) => {
      state.accessorDetails = action.payload;
    },
    setProductSponsorId: (state, action) => {
      state.productSponsorId = action.payload;
    },
    setProductSponsorName: (state, action) => {
      state.productSponsorName = action.payload;
    },
    setAccessProfileId: (state, action) => {
      state.accessProfileId = action.payload;
    },
    setAccessProfileType: (state, action) => {
      state.accessProfileType = action.payload;
    },
    setAccessorPrivileges: (state, action) => {
      state.accessorPrivileges = action.payload;
    },
    setIsRiccAdministrator: (state, action) => {
      state.isRiccAdministrator = action.payload;
    },
    setShowChangeProductManufacturer: (state, action) => {
      state.showChangeProductManufacturer = action.payload;
    },
    setRiccAdminApprovalRequiredCode: (state, action) => {
      state.riccAdmApprovalRequiredCode = action.payload;
    },
  },
});

export const {
  setSettings,
  setAccessorDetails,
  setProductSponsorId,
  setProductSponsorName,
  setAccessProfileId,
  setAccessProfileType,
  setAccessorPrivileges,
  setIsRiccAdministrator,
  setShowChangeProductManufacturer,
  setRiccAdminApprovalRequiredCode,
  setContactInfo,
} = commonSlice.actions;
export default commonSlice.reducer;
